import React, { useState } from "react";
import { url } from "../constants/url";
import { useNavigate } from "react-router-dom";

const SupportPage = () => {
  const [email, setEmail] = useState("");
  const [headline, setHeadline] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);
    try {
      const response = await fetch(url + "/api/support", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, headline, description })
      });
      if (response.status === 401) {
        localStorage.clear();
        navigate("/login");
        return;
      }
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to submit support request.");
      }
      setMessage("Support request submitted successfully.");
      setEmail("");
      setHeadline("");
      setDescription("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-3xl shadow-md max-w-4xl mx-auto">
      <h1 className="text-3xl font-semibold mb-6 text-[#AF9C80]">Support</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-bold mb-2">Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full p-2 border rounded"
            placeholder="Your email address"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-bold mb-2">
            Problem Headline:
          </label>
          <input
            type="text"
            value={headline}
            onChange={(e) => setHeadline(e.target.value)}
            required
            className="w-full p-2 border rounded"
            placeholder="Brief headline of your problem"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-bold mb-2">
            Problem Description:
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            className="w-full p-2 border rounded"
            placeholder="Detailed description of your problem"
            rows="5"
          ></textarea>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="bg-[#AF9C80] text-white py-2 px-4 rounded hover:bg-[#9a7a65]"
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
        {message && <p className="text-green-500">{message}</p>}
        {error && <p className="text-red-500">{error}</p>}
      </form>
    </div>
  );
};

export default SupportPage;
